"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgGraduateCap = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M2.001 6.915c0-.6.382-1.134.949-1.324l7.418-2.488c.411-.137.855-.137 1.265 0l7 2.348a2.011 2.011 0 011.368 1.909v9.616l1.766 2.042a1.01 1.01 0 01-.32 1.544l-.238.12c-.416.209-.95.318-1.416.318h-.584c-.466 0-.925-.11-1.341-.319l-.238-.119a1.01 1.01 0 01-.32-1.544L19 16.976v-8.72l-7.368 2.471c-.41.138-.854.138-1.264 0L2.948 8.24a1.395 1.395 0 01-.948-1.325z' }),
    react_1.default.createElement("path", { d: 'M4.001 10l6.4 2.011a2 2 0 001.2 0L18 10v4.867S16.834 17 11.001 17s-7-2.133-7-2.133V10z' }))); };
exports.default = SvgGraduateCap;
//# sourceMappingURL=GraduateCap.js.map